<template>
    <div class="filter-card">
        <h2 class="filter-title">Filtros</h2>
        <div class="filter-content">
            <label for="fecha_inicio">Desde:</label>
            <input type="date" id="fecha_inicio" v-model="fechaInicio" />

            <label for="fecha_fin">Hasta:</label>
            <input type="date" id="fecha_fin" v-model="fechaFin" />

            <button @click="applyFilters">Aplicar</button>
            <button @click="downloadCSV" class="download-button">
                Descargar CSV
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';

const fechaInicio = ref('');
const fechaFin = ref('');
const emit = defineEmits(['applyFilters', 'downloadCSV']);

const applyFilters = () => {
    emit('applyFilters', { fechaInicio: fechaInicio.value, fechaFin: fechaFin.value });
};

const downloadCSV = () => {
    emit('downloadCSV');
};
</script>

<style scoped src="../styles/filterComponent.css"></style>